module.exports = __webpack_public_path__ + "img/lightblue.9d1b2ee7.png";